import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import { Theme, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import useWindowScroll from '@react-hook/window-scroll'
import React from 'react'
import { useLocation } from 'react-router'
import ScrollToTop from 'react-scroll-up'
import { useQueryParams } from 'use-query-params'
import ArrowUpIcon from '../../../icons/ArrowUpIcon'
import { CART_URL } from '../../urls'
import { GlobalDialogFormsParams } from '../GlobalDialogForms'

export const SCROLL_TOP_BUTTON_ID = 'scroll-contact-button'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'fixed',
    right: 8,
    bottom: 5,
    height: 55,
    width: 55,
    display: 'flex',
    zIndex: 100,
    cursor: 'pointer',

    '@media (max-width:1700px)': {
      '&[data-product=true]': {
        bottom: 80,
      },
    },
  },
  button: {
    backgroundColor: '#fff',
    bottom: 0,
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #d8d8d8',
    opacity: 1,
    textAlign: 'left',
    borderRadius: '50px',
  },
  scrollTopBtn: {
    width: 55,
    opacity: 1,
    visibility: 'visible',
    transition: 'visibility 0s linear 0s,opacity .2s ease-out',
    padding: 0,
    zIndex: 102,
  },
  contactBtn: {
    padding: 5,
    marginRight: -1,
    width: 55,
    position: 'absolute',
    zIndex: 101,
    [theme.breakpoints.down('xs')]: {
      width: 55,
      height: 45,
      marginRight: 0,
    },
  },
  mobileContactBtn: {
    position: 'fixed',
    zIndex: 101,
    right: 3,
    bottom: 100,
    cursor: 'pointer',
  },
}))

const ScrollBtn: React.FC = () => {
  const classes = useStyles()
  const theme = useTheme()
  const mdDown = useMediaQuery(theme.breakpoints.down('md'))
  const { pathname } = useLocation()
  const scrollY = useWindowScroll(60)
  const [, setParams] = useQueryParams(GlobalDialogFormsParams)

  if (
    (pathname.includes('checkout') ||
      // pathname.includes('products') ||
      pathname.replace(/\//gm, '').includes(CART_URL.replace(/\//gm, ''))) &&
    mdDown
  ) {
    return null
  }
  return (
    <div className={classes.root} id={SCROLL_TOP_BUTTON_ID} data-product={pathname.includes('products')}>
      {scrollY <= 500 && (
        <span
          className={`${classes.button} ${classes.contactBtn}`}
          onClick={() => setParams({ global_dialog_form: 'contactUs' }, 'replaceIn')}
        >
          <EmailOutlinedIcon />
        </span>
      )}
      <ScrollToTop showUnder={500} duration={500} style={{ position: 'initial' }}>
        <span className={`${classes.button} ${classes.scrollTopBtn}`}>
          <ArrowUpIcon viewBox='0 0 32 32' />
        </span>
      </ScrollToTop>
    </div>
  )
}

export default ScrollBtn
